import { useState } from "react";
import {
    CubeIcon,
    ShoppingCartIcon,
    ScaleIcon,
    CalendarDaysIcon,
    MagnifyingGlassIcon,
    ArrowsRightLeftIcon,
    BriefcaseIcon,
} from "@heroicons/react/24/outline";
import SelfStockReport from "./Selfstockreport";
import DailyPurchaseReport from "./DailyPurchaseReport";
import DailySaudaReport from "./DailySaudaReport";
import TrailBalanceReport from "./TrailBalanceReport";
import PendingPaymentReport from "./PendingPayment";
import AccountsClosingReport from "./AccountsClosingReport"

const todayISO = () => new Date().toISOString().slice(0, 10);

const TABS = [
    { id: "self-stock",      label: "Self Stock Report", icon: CubeIcon },
    { id: "daily-purchase",  label: "Daily Purchase And Sale",     icon: ShoppingCartIcon },
    { id: "trial-balance",   label: "Trial Balance Report",     icon: ScaleIcon },
    { id: "pending-payment", label: "Pending Payment Report",  icon: ArrowsRightLeftIcon },
    { id: "account-report", label: "Accounts Closing Report",  icon: BriefcaseIcon },
];

export default function ClosingStock() {
    const [active, setActive]       = useState("self-stock");
    const [inputDate, setInputDate] = useState(todayISO());
    const [activeDate, setActiveDate] = useState(todayISO());

    const handleFetch = () => {
        if (inputDate) setActiveDate(inputDate);
    };

    const renderActiveContent = () => {
        switch (active) {
            case "self-stock":
                return <SelfStockReport toDate={activeDate} />;
            case "daily-purchase":
                return <DailyPurchaseReport toDate={activeDate} />;
            case "daily-sauda":
                return <DailySaudaReport toDate={activeDate} />;
            case "trial-balance":
                return <TrailBalanceReport toDate={activeDate} />;
            case "pending-payment":
                return <PendingPaymentReport />;

            case "account-report":
                return <AccountsClosingReport toDate={activeDate}  />;

            default:
                return null;
        }
    };

    return (
        /* The main wrapper stays visible, but we remove margins for print */
        <div className="bg-slate-50/50 p-1 lg:p-1 print:p-0 print:bg-white" style={{ marginTop: "-80px" }}>
            <div>
                <div className="bg-white rounded-3xl border border-slate-200 shadow-xl shadow-slate-200/50 overflow-hidden print:border-none print:shadow-none print:rounded-none">

                    {/* ── Date Bar: Hidden in Print ── */}
                    <div className="flex items-center gap-4 px-6 py-3 bg-gradient-to-r from-slate-800 to-slate-700 border-b border-slate-600 print:hidden">
                        <div className="flex items-center gap-2 text-slate-300">
                            <CalendarDaysIcon className="w-4 h-4" />
                            <span className="text-[11px] font-bold uppercase tracking-widest text-slate-400">As On Date</span>
                        </div>

                        <input
                            type="date"
                            value={inputDate}
                            onChange={(e) => setInputDate(e.target.value)}
                            className="px-3 py-1.5 rounded-lg text-xs font-semibold bg-slate-900/60 text-white border border-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 cursor-pointer"
                        />

                        <button
                            onClick={handleFetch}
                            disabled={!inputDate}
                            className="flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-xs font-bold bg-blue-600 text-white hover:bg-blue-500 disabled:opacity-40 transition-all shadow-sm"
                        >   
                            Get Report
                        </button>

                        {activeDate && (
                            <div className="ml-auto flex items-center gap-2 px-3 py-1 rounded-full bg-blue-600/20 border border-blue-500/30">
                                <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse" />
                                <span className="text-[11px] font-semibold text-blue-300">
                                    Date : {new Date(activeDate).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                                </span>
                            </div>
                        )}
                    </div>

                    {/* ── Navigation Tabs: Hidden in Print ── */}
                    <div className="bg-slate-50/80 border-b border-slate-200 px-6 pt-4 print:hidden">
                        <nav
                            className="flex gap-2 overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
                            aria-label="Tabs"
                        >
                            {TABS.map((tab) => {
                                const isActive = active === tab.id;
                                return (
                                    <button
                                        key={tab.id}
                                        onClick={() => setActive(tab.id)}
                                        className={`
                                            flex-shrink-0 whitespace-nowrap group relative flex items-center gap-2.5 px-6 py-4 text-sm font-bold transition-all duration-300
                                            rounded-t-xl border-x border-t -mb-px
                                            ${isActive
                                                ? "bg-white border-slate-200 text-blue-600 shadow-[0_-4px_12px_rgba(0,0,0,0.02)]"
                                                : "bg-transparent border-transparent text-slate-500 hover:text-slate-800 hover:bg-slate-200/40"
                                            }
                                        `}
                                    >
                                        <tab.icon className={`w-5 h-5 transition-colors ${isActive ? "text-blue-600" : "text-slate-400 group-hover:text-slate-600"}`} />
                                        {tab.label}
                                        {isActive && (
                                            <span className="absolute top-0 left-0 right-0 h-1 bg-blue-600 rounded-full mx-2" />
                                        )}
                                    </button>
                                );
                            })}
                        </nav>
                    </div>

                    {/* ── Dynamic Content: Visible in Print ── */}
                    <div className="relative min-h-[600px] print:min-h-0">
                        {renderActiveContent()}
                    </div>

                </div>
            </div>
        </div>
    );
}



















// import { useState } from "react";
// import {
//     CubeIcon,
//     ShoppingCartIcon,
//     ScaleIcon,
//     CalendarDaysIcon,
//     ArrowsRightLeftIcon,
//     ChevronLeftIcon,
//     ChevronRightIcon,
// } from "@heroicons/react/24/outline";
// import SelfStockReport from "./Selfstockreport";
// import DailyPurchaseReport from "./DailyPurchaseReport";
// import DailySaudaReport from "./DailySaudaReport";
// import TrailBalanceReport from "./TrailBalanceReport";
// import PendingPaymentReport from "./PendingPayment";

// const todayISO = () => new Date().toISOString().slice(0, 10);

// const TABS = [
//     { id: "self-stock",      label: "Self Stock Report", icon: CubeIcon },
//     { id: "daily-purchase",  label: "Daily Purchase And Sale",     icon: ShoppingCartIcon },
//     { id: "trial-balance",   label: "Trial Balance Report",     icon: ScaleIcon },
//     { id: "pending-payment", label: "Pending Payment Report",  icon: ArrowsRightLeftIcon },
// ];

// // Tabs where date shifting should be disabled
// const DATE_DISABLED_TABS = ["self-stock", "pending-payment"];

// export default function ClosingStock() {
//     const [active, setActive]       = useState("self-stock");
//     const [inputDate, setInputDate] = useState(todayISO());
//     const [activeDate, setActiveDate] = useState(todayISO());

//     const isDateDisabled = DATE_DISABLED_TABS.includes(active);

//     const handleFetch = () => {
//         if (inputDate) setActiveDate(inputDate);
//     };

//     // Shift date by +/- days
//     const shiftDate = (days) => {
//         if (isDateDisabled) return; // Prevent shifting if disabled
//         const current = new Date(inputDate);
//         current.setDate(current.getDate() + days);
//         const newDateStr = current.toISOString().slice(0, 10);
//         setInputDate(newDateStr);
//         setActiveDate(newDateStr);
//     };

//     const handlePrevDate = () => shiftDate(-1);
//     const handleNextDate = () => shiftDate(1);
//     const goToToday = () => {
//         if (isDateDisabled) return;
//         const today = todayISO();
//         setInputDate(today);
//         setActiveDate(today);
//     };

//     const formatDateDisplay = (dateStr) => {
//         return new Date(dateStr).toLocaleDateString("en-IN", { 
//             day: "2-digit", 
//             month: "short", 
//             year: "numeric" 
//         });
//     };

//     const renderActiveContent = () => {
//         switch (active) {
//             case "self-stock":
//                 return <SelfStockReport toDate={activeDate} />;
//             case "daily-purchase":
//                 return <DailyPurchaseReport toDate={activeDate} />;
//             case "daily-sauda":
//                 return <DailySaudaReport toDate={activeDate} />;
//             case "trial-balance":
//                 return <TrailBalanceReport toDate={activeDate} />;
//             case "pending-payment":
//                 return <PendingPaymentReport />;
//             default:
//                 return null;
//         }
//     };

//     return (
//         <div className="bg-slate-50/50 p-1 lg:p-1 print:p-0 print:bg-white" style={{ marginTop: "-80px" }}>
//             <div>
//                 <div className="bg-white rounded-3xl border border-slate-200 shadow-xl shadow-slate-200/50 overflow-hidden print:border-none print:shadow-none print:rounded-none">

//                     {/* ── Date Bar: Hidden in Print ── */}
//                     <div className="flex items-center gap-4 px-6 py-3 bg-gradient-to-r from-slate-800 to-slate-700 border-b border-slate-600 print:hidden">
//                         <div className="flex items-center gap-2 text-slate-300">
//                             <CalendarDaysIcon className="w-4 h-4" />
//                             <span className="text-[11px] font-bold uppercase tracking-widest text-slate-400">As On Date</span>
//                         </div>

//                         <input
//                             type="date"
//                             value={inputDate}
//                             onChange={(e) => setInputDate(e.target.value)}
//                             disabled={isDateDisabled}
//                             className={`px-3 py-1.5 rounded-lg text-xs font-semibold bg-slate-900/60 text-white border border-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 cursor-pointer ${isDateDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
//                         />

//                         <button
//                             onClick={handleFetch}
//                             disabled={!inputDate || isDateDisabled}
//                             className="flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-xs font-bold bg-blue-600 text-white hover:bg-blue-500 disabled:opacity-40 transition-all shadow-sm"
//                         >   
//                             Get Report
//                         </button>

//                         {activeDate && (
//                             <div className={`ml-auto flex items-center gap-2 px-3 py-1 rounded-full bg-blue-600/20 border border-blue-500/30 ${isDateDisabled ? 'opacity-50' : ''}`}>
//                                 <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse" />
//                                 <span className="text-[11px] font-semibold text-blue-300">
//                                     Date : {formatDateDisplay(activeDate)}
//                                 </span>
//                             </div>
//                         )}
//                     </div>

//                     {/* ── Navigation Tabs: Hidden in Print ── */}
//                     <div className="bg-slate-50/80 border-b border-slate-200 px-6 pt-4 print:hidden">
//                         <nav
//                             className="flex gap-2 overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] items-center"
//                             aria-label="Tabs"
//                         >
//                             {TABS.map((tab) => {
//                                 const isActive = active === tab.id;
//                                 return (
//                                     <button
//                                         key={tab.id}
//                                         onClick={() => setActive(tab.id)}
//                                         className={`
//                                             flex-shrink-0 whitespace-nowrap group relative flex items-center gap-2.5 px-6 py-4 text-sm font-bold transition-all duration-300
//                                             rounded-t-xl border-x border-t -mb-px
//                                             ${isActive
//                                                 ? "bg-white border-slate-200 text-blue-600 shadow-[0_-4px_12px_rgba(0,0,0,0.02)]"
//                                                 : "bg-transparent border-transparent text-slate-500 hover:text-slate-800 hover:bg-slate-200/40"
//                                             }
//                                         `}
//                                     >
//                                         <tab.icon className={`w-5 h-5 transition-colors ${isActive ? "text-blue-600" : "text-slate-400 group-hover:text-slate-600"}`} />
//                                         {tab.label}
//                                         {isActive && (
//                                             <span className="absolute top-0 left-0 right-0 h-1 bg-blue-600 rounded-full mx-2" />
//                                         )}
//                                     </button>
//                                 );
//                             })}

//                             {/* ── Date Shifter (Right End) ── */}
//                             <div className={`ml-auto flex items-center gap-2 pl-6 border-l border-slate-200 ${isDateDisabled ? 'opacity-50 pointer-events-none' : ''}`}>
//                                 <button
//                                     onClick={handlePrevDate}
//                                     disabled={isDateDisabled}
//                                     title={isDateDisabled ? "Date selection disabled for this report" : "Previous Day (-1)"}
//                                     className="flex items-center justify-center w-8 h-8 rounded-lg bg-white border border-slate-300 text-slate-600 hover:bg-slate-100 hover:border-slate-400 hover:text-blue-600 transition-all shadow-sm active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed"
//                                 >
//                                     <ChevronLeftIcon className="w-4 h-4" />
//                                 </button>
                                
//                                 <div className="flex flex-col items-center min-w-[90px] px-2">
//                                     <span className="text-[9px] font-bold text-slate-400 uppercase tracking-wider leading-none">Current</span>
//                                     <span className="text-xs font-bold text-slate-700 leading-tight">
//                                         {formatDateDisplay(activeDate)}
//                                     </span>
//                                 </div>

//                                 <button
//                                     onClick={handleNextDate}
//                                     disabled={isDateDisabled}
//                                     title={isDateDisabled ? "Date selection disabled for this report" : "Next Day (+1)"}
//                                     className="flex items-center justify-center w-8 h-8 rounded-lg bg-white border border-slate-300 text-slate-600 hover:bg-slate-100 hover:border-slate-400 hover:text-blue-600 transition-all shadow-sm active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed"
//                                 >
//                                     <ChevronRightIcon className="w-4 h-4" />
//                                 </button>

//                                 <button
//                                     onClick={goToToday}
//                                     disabled={isDateDisabled}
//                                     title={isDateDisabled ? "Date selection disabled for this report" : "Go to Today"}
//                                     className="ml-1 px-3 py-1.5 rounded-lg text-[10px] font-bold bg-blue-50 text-blue-600 border border-blue-200 hover:bg-blue-100 hover:border-blue-300 transition-all disabled:opacity-40 disabled:cursor-not-allowed"
//                                 >
//                                     Today
//                                 </button>
//                             </div>
//                         </nav>
//                     </div>

//                     {/* ── Dynamic Content: Visible in Print ── */}
//                     <div className="relative min-h-[600px] print:min-h-0">
//                         {renderActiveContent()}
//                     </div>

//                 </div>
//             </div>
//         </div>
//     );
// }
